import queryString from 'query-string'

const GET_AVAILABLE_ASSESSORS = 'dofe-fo/assessor/GET_AVAILABLE_ASSESSORS'
const GET_AVAILABLE_ASSESSORS_SUCCESS = 'dofe-fo/assessor/GET_AVAILABLE_ASSESSORS_SUCCESS'
const GET_AVAILABLE_ASSESSORS_FAIL = 'dofe-fo/assessor/GET_AVAILABLE_ASSESSORS_FAIL'

const GET_ASSESSOR_AFFILIATIONS_OVERVIEW = 'dofe-fo/assessor/GET_ASSESSOR_AFFILIATIONS_OVERVIEW'
const GET_ASSESSOR_AFFILIATIONS_OVERVIEW_SUCCESS = 'dofe-fo/assessor/GET_ASSESSOR_AFFILIATIONS_OVERVIEW_SUCCESS'
const GET_ASSESSOR_AFFILIATIONS_OVERVIEW_FAIL = 'dofe-fo/assessor/GET_ASSESSOR_AFFILIATIONS_OVERVIEW_FAIL'

const UPDATE_WWC = 'dofe-fo/assessor/UPDATE_WWC'
const UPDATE_WWC_SUCCESS = 'dofe-fo/assessor/UPDATE_WWC'
const UPDATE_WWC_FAIL = 'dofe-fo/assessor/UPDATE_WWC'

const GET_WWC_LIST = 'dofe-fo/assessor/GET_WWC_LIST'
const GET_WWC_LIST_SUCCESS = 'dofe-fo/assessor/GET_WWC_LIST_SUCCESS'
const GET_WWC_LIST_FAIL = 'dofe-fo/assessor/GET_WWC_LIST_FAIL'

const ACCEPT_ACTIVITY = 'dofe-fo/assessor/ACCEPT_ACTIVITY'
const ACCEPT_ACTIVITY_SUCCESS = 'dofe-fo/assessor/ACCEPT_ACTIVITY_SUCCESS'
const ACCEPT_ACTIVITY_FAIL = 'dofe-fo/assessor/ACCEPT_ACTIVITY_FAIL'

const REJECT_ACTIVITY = 'dofe-fo/assessor/REJECT_ACTIVITY'
const REJECT_ACTIVITY_SUCCESS = 'dofe-fo/assessor/REJECT_ACTIVITY_SUCCESS'
const REJECT_ACTIVITY_FAIL = 'dofe-fo/assessor/REJECT_ACTIVITY_FAIL'

const UPDATE_ASSESSOR_ACTIVITY = 'dofe-fo/assessor/UPDATE_ASSESSOR_ACTIVITY'
const UPDATE_ASSESSOR_ACTIVITY_SUCCESS = 'dofe-fo/assessor/UPDATE_ASSESSOR_ACTIVITY_SUCCESS'
const UPDATE_ASSESSOR_ACTIVITY_FAIL = 'dofe-fo/assessor/UPDATE_ASSESSOR_ACTIVITY_FAIL'

const SET_FILTER = 'dofe-bo/assessor/SET_FILTER'

const initialState = {
  loading: false,
  loaded: false,
  list: [],
  detail: {},
  sort: '',
  offset: 0,
  limit: 50,
  pages: 1,
  count: null,
  filter: '',
  wwc: {
    loaded: false,
    loading: false,
    list: [],
    sort: '',
    offset: 0,
    limit: 50,
    pages: 1,
    count: null,
    filter: ''
  }
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_AVAILABLE_ASSESSORS:
      return {
        ...state,
        loading: true
      }
    case GET_AVAILABLE_ASSESSORS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        list: action.result || [],
        count: Number(action.headers['x-total-count']),
        pages: Math.ceil(
          Number(action.headers['x-total-count']) / state.limit
        ) || state.pages
      }
    case GET_AVAILABLE_ASSESSORS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case ACCEPT_ACTIVITY:
      return {
        ...state,
        loading: true
      }
    case ACCEPT_ACTIVITY_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true
      }
    case ACCEPT_ACTIVITY_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case REJECT_ACTIVITY:
      return {
        ...state,
        loading: true
      }
    case REJECT_ACTIVITY_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true
      }
    case REJECT_ACTIVITY_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case GET_ASSESSOR_AFFILIATIONS_OVERVIEW:
      return {
        ...state,
        affiliationsOverview: {
          ...state.affiliations_overview,
          loading: true
        }
      }
    case GET_ASSESSOR_AFFILIATIONS_OVERVIEW_SUCCESS:
      return {
        ...state,
        affiliationsOverview: {
          ...state.affiliations_overview,
          loading: false,
          loaded: true,
          error: null,
          data: action.result
        }
      }
    case GET_ASSESSOR_AFFILIATIONS_OVERVIEW_FAIL:
      return {
        ...state,
        affiliationsOverview: {
          ...state.logs,
          loading: false,
          loaded: false,
          error: action.error
        }
      }
    case SET_FILTER:
      return Object.assign({}, state, {
        filter: action.filterBy
      })
    case GET_WWC_LIST:
      return {
        ...state,
        wwc: {
          ...state.wwcStatus,
          loading: true
        }
      }
    case GET_WWC_LIST_SUCCESS:
      return {
        ...state,
        wwc: {
          ...state.wwcStatus,
          loading: false,
          loaded: true,
          error: null,
          list: action.result || [],
          count: Number(action.headers['x-total-count']),
          pages: Math.ceil(
            Number(action.headers['x-total-count']) / state.limit
          ) || state.pages
        }
      }
    case GET_WWC_LIST_FAIL:
      return {
        ...state,
        wwc: {
          ...state.wwcStatus,
          loading: false,
          loaded: false,
          error: action.error
        }
      }
    default:
      return state
  }
}

export function getAvailableAssessorsForActivityCategory(orgId, activityCategoryId) {
  return {
    types: [GET_AVAILABLE_ASSESSORS, GET_AVAILABLE_ASSESSORS_SUCCESS, GET_AVAILABLE_ASSESSORS_FAIL],
    promise: client =>
      client.get(`api/assessors/organizations/${orgId}/activity-category/${activityCategoryId}?` + queryString.stringify({ showOnlyPublic: true }), { removeToken: true })
  }
}

export function getAssessorOverview(assessorId) {
  return {
    types: [GET_ASSESSOR_AFFILIATIONS_OVERVIEW, GET_ASSESSOR_AFFILIATIONS_OVERVIEW_SUCCESS, GET_ASSESSOR_AFFILIATIONS_OVERVIEW_FAIL],
    promise: client =>
      client.get(`api/assessors/${assessorId}/affiliations-overview`, {})
  }
}

export function updateWWC(personId, orgId, data) {
  return {
    types: [UPDATE_WWC, UPDATE_WWC_SUCCESS, UPDATE_WWC_FAIL],
    promise: client =>
      client.post(`api/assessors/${personId}/organization/${orgId}/wwc/update`, { data })
  }
}

export function getWWCList(personId) {
  return {
    types: [GET_WWC_LIST, GET_WWC_LIST_SUCCESS, GET_WWC_LIST_FAIL],
    promise: client =>
      client.get(`api/assessors/wwc/${personId}/list?with=ASSESSOR_FILE,ASSESSOR,ORGANIZATION`)
  }
}

export function acceptActivity(personId, data) {
  return {
    types: [ACCEPT_ACTIVITY, ACCEPT_ACTIVITY_SUCCESS, ACCEPT_ACTIVITY_FAIL],
    promise: client => client.post(`api/assessors/${personId}/activity/accept`, { data })
  }
}

export function acceptActivityByLink(authorizationCode) {
  return {
    types: [ACCEPT_ACTIVITY, ACCEPT_ACTIVITY_SUCCESS, ACCEPT_ACTIVITY_FAIL],
    promise: client => client.post(`api/assessors/activity/accept/using-authorization-code?authorizationCode=${authorizationCode}`,
      { removeToken: true }
    )
  }
}

export function rejectActivityByLink(data, authorizationCode) {
  return {
    types: [REJECT_ACTIVITY, REJECT_ACTIVITY_SUCCESS, REJECT_ACTIVITY_FAIL],
    promise: client => client.post(`api/assessors/activity/reject/using-authorization-code?authorizationCode=${authorizationCode}`,
      { data, removeToken: true }
    )
  }
}

export function updateAssessorActivity(id, data) {
  return {
    types: [UPDATE_ASSESSOR_ACTIVITY, UPDATE_ASSESSOR_ACTIVITY_SUCCESS, UPDATE_ASSESSOR_ACTIVITY_FAIL],
    promise: client => client.post(`api/assessor-activity-category/${id}/update`, { data })
  }
}

export function setFilter(filterBy) {
  return {
    type: SET_FILTER,
    filterBy
  }
}
